export const RouteMappings: Record<string, string> = {
  '/users': 'UserList',
  '/users/create': 'CreateUser',
  '/users/edit/:userId': 'EditUser',
  '/groups': 'UserGroupList',
  '/groups/create': 'CreateUserGroup',
  '/groups/edit/:groupId/:groupName?': 'EditUserGroup',
  '/apikeys': 'ApiKeyGroupList',
  '/apikeys/create': 'CreateApiKeyGroup',
  '/apikeys/:apiKeyGroupName': 'ApiKeyList',
};

export const CreateApiKeyRoute = 'CreateApiKey';
